import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'

const PaymentIntegrations = () => import('@/pmd/pages/payments/v2/PaymentIntegrations.vue')
const ManagePaymentIntegrations = () => import('@/pmd/pages/payments/v2/ManagePaymentIntegrations.vue')
const AllPaymentIntegrations = () => import('@/pmd/pages/payments/v2/AllPaymentIntegrations.vue')
const StripePaymentMethodsApp = () => import('@/pmd/pages/payments/v2/ManageStripePaymentMethods.vue')

export const PaymentIntegrationsRoute: RouteConfig[] = [
  {
    path: 'payments/integrations',
    name: 'payment-integrations-v2',
    component: PaymentIntegrations,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'payments/integrations/:route/manage',
    name: 'manage-payment-integrations',
    component: ManagePaymentIntegrations,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'payments/integrations/all',
    name: 'all-payment-integrations',
    component: AllPaymentIntegrations,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'payments/integrations/stripe/payment-methods',
    name: 'manage-stripe-payment-method',
    component: StripePaymentMethodsApp,
    beforeEnter: requireAuthAndLocation,
  }
]
